export const User = (json: IUser): IUserModel => {
	const fromJSON = (json: IUser) => {
		const { phone_number, email_verified_at, last_name, consents, client, ...rest } = json
		return {
			...rest,
			client: client ? BookingClient(client) : null,
			phoneNumber: phone_number,
			lastName: last_name,
			emailVerifiedAt: email_verified_at,
			consents: consents ? UserConsents(consents) : null,
		}
	}

	return { ...fromJSON(json) }
}

export const userToJSON = (obj: Partial<IUserModel>): Partial<IUser> => {
	const { phoneNumber, emailVerifiedAt, lastName, consents, ...rest } = obj
	return {
		email_verified_at: emailVerifiedAt,
		phone_number: phoneNumber,
		last_name: lastName,
		consents: consents ? userConsentsToJSON(consents) : null,
		...rest,
	}
}

export const userRegisterToJSON = (obj: IUserRegisterModel): IUserRegister => {
	const { phoneNumber, lastName, consents, ...rest } = obj
	return {
		...rest,
		phone_number: phoneNumber.trim(),
		last_name: lastName.trim(),
		consents: userConsentsToJSON(consents),
	}
}

export const userLoginToJSON = (obj: IUserLoginModel): IUserLogin => {
	const { phoneNumber, ...rest } = obj
	return {
		...rest,
		phone_number: phoneNumber.trim(),
	}
}
